import axios from "axios";
import { URL, getHeaders, } from "./config";
export const sendingEmail = async (obj, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/sendDocumentEmail`;
    return axios({
        method: "post",
        url: url,
        headers: headers,
        data: obj,
    })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const sendSimpleEmailApi = async (obj, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/sendSimpleEmail`;
    return axios({
        method: "post",
        url: url,
        headers: headers,
        data: obj,
    })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
export const sentNoteToCustomer = async (obj, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/sendOrderNoteEmail`;
    axios({
        method: "post",
        url: url,
        headers: headers,
        data: obj,
    })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
